import { render } from "./SidenavListStudent.vue?vue&type=template&id=2036ebf0"
import script from "./SidenavListStudent.vue?vue&type=script&lang=js"
export * from "./SidenavListStudent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__